exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-header {\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.icon-card {\r\n    color: #3FC181;\r\n}\r\n.icon-card-arrow{\r\n    font-size: x-large;\r\n    font-weight: 900;\r\n}\r\n.icono-inicial{\r\n    margin-top: 5px;\r\n    margin-right: -5px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/header-card-no-expertos/header-card-no-expertos.component.css
// module id = ../../../../../src/app/components/header-card-no-expertos/header-card-no-expertos.component.css
// module chunks = main